import React from 'react';
import { DropDownArrow2 } from '../../assets/icons';
import { capitalizeWords, BoxSizeFormat } from '../../utils';

export const DropDown = ({
  dropdownMenu,
  value,
  setValue,
  className = '',
  printBox = false,
  capitalize,
  disabled = false,
}) => {
  const handleDropdownMenu = (item) => {
    setValue(item);
  };

  // Helper function to format display text for dropdown items
  const formatDisplayText = (item) => {
    if (printBox) {
      return BoxSizeFormat(item);
    } else if (item === 'invoice_no') {
      return capitalize ? 'invoice_no' : capitalizeWords('invoice_no');
    } else if (item === 'vendor_id,partner_id' || item === 'partner_id') {
      return capitalize ? 'Contact' : capitalizeWords('Contact');
    } else if (item === 'physical_container_no') {
      return capitalize ? 'container_no' : capitalizeWords('container_no');
    } else if (item === 'invoice_number') {
      return capitalize ? 'invoice_no' : capitalizeWords('invoice_no');
    } else {
      return capitalize ? item : capitalizeWords(item);
    }
  };

  return (
    <div
      className={`${className} custom-dropdown-3 d-flex align-items-center justify-content-center`}>
      <div className="dropdown w-100">
        <button
          className="btn w-100 dropdown-toggle bg-white d-flex align-items-center justify-content-between"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          disabled={disabled}>
          {formatDisplayText(value)}
          <DropDownArrow2 />
        </button>
        <ul className="dropdown-menu bg-white border-0 py-0" aria-labelledby="dropdownMenuButton1">
          {dropdownMenu.map((item, index) => (
            <li
              key={index}
              onClick={() => handleDropdownMenu(item)}
              className={`${item === value ? 'bg-dark-subtle ' : ''}`}>
              <div className="dropdown-item d-flex align-items-center justify-content-start">
                {formatDisplayText(item)}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
